<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { Capacitor } from '@capacitor/core';
import router from '@/router/index.js';
import { useTermsConsentStore } from '@stores/termsConsent';

const emit = defineEmits(['applyEnifClub']);

const props = defineProps({
  splitSiteCode: {
    type: Number,
    default: null
  }
});

const store = useTermsConsentStore();
const isConsent = computed(() => store.enifClubConsent);
const isNavigatingToPdf = ref(false);

const clickEnifClubPdfLink = () => {
  // propsから受け取ったURLを使用
  if (props.splitSiteCode !== null) {
    store.setConsent('enifClubTerms');
    const platform = Capacitor.getPlatform();
    if (platform === 'ios' || platform === 'android') {
      isNavigatingToPdf.value = true;
      router.push({
        path: '/pdf-viewer/enif-club-terms'
        , query: {
          reopenModal: 'enifClubApplyModal'
          , returnPath: router.currentRoute.value.path
          , splitSiteCode: props.splitSiteCode
        }
      });
    } else {
      window.open(`/static/base_${props.splitSiteCode}/enif_club_terms.pdf`, '_blank', 'noopener');
    }
  }
};


const agreeAndReset = () => {
  store.resetConsent('enifClubTerms');
  emit('applyEnifClub');
};

const onModalHidden = () => {
  if (isNavigatingToPdf.value) {
    isNavigatingToPdf.value = false;
    return;
  }
  store.resetConsent('enifClubTerms');
};

const onModalShown = () => {
  // 利用規約リンクのフォントカラーが不安定になる対策
  document.getElementById('enifClubApplyModal')?.blur();
};

const onModalBeforeHide = () => {
  // 利用規約リンクのフォントカラーが不安定になる対策
  const el = document.getElementById('enifClubApplyModal');
  if (el && document.activeElement === el) {
    document.body.focus();
  }
};

onMounted(() => {
  const el = document.getElementById('enifClubApplyModal');
  el?.addEventListener('shown.bs.modal', onModalShown);
  el?.addEventListener('hide.bs.modal', onModalBeforeHide);
  el?.addEventListener('hidden.bs.modal', onModalHidden);
});

onUnmounted(() => {
  const el = document.getElementById('enifClubApplyModal');
  el?.removeEventListener('shown.bs.modal', onModalShown);
  el?.removeEventListener('hide.bs.modal', onModalBeforeHide);
  el?.removeEventListener('hidden.bs.modal', onModalHidden);
});

</script>

<template>
  <div class="modal com_modal2 fade" id="enifClubApplyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1">ご確認ください</h3>
          <p class="com_fs14 com_center1">ENIF-clubの利用規約をご確認いただき、同意ボタンを押してください。</p>
          <p class="com_fs14 com_center1">
            <a href="#" target="_blank" class="com_link2" @click.prevent="clickEnifClubPdfLink">ENIF-club利用規約
              <img src="/front/assets/common/img/icon_pdf1.png" alt="" class="com_icon_pdf1">
            </a>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1" data-bs-dismiss="modal" :disabled="!isConsent" @click="agreeAndReset">同意する</button>
          <button type="button" class="btn com_btn2" data-bs-dismiss="modal">戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>